import axios from 'axios';

export const checkUserIsAdmin = currentUser => {
  if (!currentUser || !Array.isArray(currentUser.userRoles)) return false;
  const { userRoles } = currentUser;
  if (userRoles.includes('admin')) return true;

  return false;
}

export const apiInstance = axios.create({
  baseURL: 'https://us-central1-catalogue-34568.cloudfunctions.net/api'
  // baseURL: 'http://localhost:5001/catalogue-34568/us-central1/api'
});